import React from "react";
import {Container} from "react-bootstrap";
import {PiArrowRight} from "react-icons/pi";
import NutzungLayout from "../../Components/Nutzung/NutzungLayout.jsx";
import NutzungWidget from "../../Components/Nutzung/NutzungWidget.jsx";
import useNutzungFilter from "../../Components/Nutzung/useNutzungFilter.js";
import useStatisticsData from "../../Components/Statistics/useStatisticsData.js";
import {formatNumber} from "../../Components/Statistics/format.js";
import {SeiteLink} from "../../Components/Nutzung/Links.jsx";

/**
 * Häufigste Übergänge von Seite zu Seite (Auftrag Teil 5, Endpunkt
 * /nutzung/daten/wege). Bewusst als lesbare Liste statt Flussdiagramm -
 * "Lesbarkeit geht vor" laut Auftrag. Beide Seiten sind über SeiteLink
 * verlinkt (Kernanforderung 2); die vom Server mitgelieferten Klartexte
 * (von_seite/nach_seite) werden dabei bewusst NICHT angezeigt - seitenName()
 * über routeLabels.js bleibt die einzige Übersetzungsstelle im Frontend.
 */
export default function NutzungWege() {
    const nutzungFilters = useNutzungFilter();
    const {filters} = nutzungFilters;
    const {data, loading, error} = useStatisticsData("/nutzung/daten/wege", filters);

    const rows = Array.isArray(data) ? [...data].sort((a, b) => (b.anzahl || 0) - (a.anzahl || 0)) : [];

    return (
        <Container fluid className="pt-2 pb-4">
            <NutzungLayout gruppe="Seiten" titel="Wege durchs System" nutzungFilters={nutzungFilters}>
                <NutzungWidget
                    title="Häufigste Übergänge"
                    help="Wie oft Mitarbeiter im gewählten Zeitraum direkt von der einen zur anderen Seite gewechselt sind, absteigend nach Häufigkeit."
                    loading={loading}
                    error={error}
                    empty={!loading && !error && rows.length === 0}
                    height={280}
                >
                    <ul className="list-unstyled mb-0 d-flex flex-column">
                        {rows.map((weg, index) => (
                            <li
                                key={`${weg.von_route}-${weg.nach_route}`}
                                className={`d-flex align-items-center flex-wrap gap-2 py-2 ${index === 0 ? "" : "border-top"}`}
                            >
                                <span className="fw-semibold">
                                    <SeiteLink route={weg.von_route} />
                                </span>
                                <PiArrowRight className="text-muted flex-shrink-0" aria-hidden="true" />
                                <span className="fw-semibold">
                                    <SeiteLink route={weg.nach_route} />
                                </span>
                                <span className="text-muted small ms-auto">
                                    {formatNumber(weg.anzahl)}-mal · {formatNumber(weg.nutzer)} {weg.nutzer === 1 ? "Person" : "Personen"}
                                </span>
                            </li>
                        ))}
                    </ul>
                </NutzungWidget>
            </NutzungLayout>
        </Container>
    );
}
